// extracted by mini-css-extract-plugin
export default {"layout":"user-management_layout__IMZwh"};